// extracted by mini-css-extract-plugin
module.exports = {"productsList":"products-list_productsList__mbh85"};